import axiosAPI from './axiosAPI.js'
import PG from '../store/plugin.js'

const actions = {
  ChangeImageStatus(context, status) {
    context.commit('SENDIMAGE', status)
  },

  ChangeCenterImageStatus(context, status) {
    context.commit('SENDCENTERIMAGE', status)
  },

  ChangeGetMemberList(context, status) {
    context.commit('GETMEMBERLIST', status)
  },

  //儲存對話內容
  addChat(context, value) {
    axiosAPI.instance
      .post('/Chat', value)
      .then((res) => {
        if (res.data.Code == 200) {
          context.commit('SENDMES', true)
        } else if (res.data.Code == 401) {
          alert('您已超過一小時未執行任何操作，系統將重新載入頁面')
          window.location.reload()
        } else if (res.data.Code == 500) {
          alert('系統忙線中，請稍後再試')
        }
      })
      .catch((error) => {
        // console.log('error', error)
        alert(`${error}`)
        window.location.reload()
      })
  },
  async addChatImage(context, value) {
    await axiosAPI.instanceForm
      .post('/Chat/Image', value)
      .then((res) => {
        if (res.data.Code == 200) {
          context.commit('ADDCHATIMAGE', res.data.Data)
          context.commit('SENDIMAGE', true)
        } else if (res.data.Code == 251) {
          alert('檔案上傳失敗，圖片訊息存取錯誤')
        } else if (res.data.Code == 252) {
          alert('檔案上傳失敗，只允許上傳jpg/png/jpeg')
        } else if (res.data.Code == 401) {
          alert('您已超過一小時未執行任何操作，系統將重新載入頁面')
          window.location.reload()
        } else if (res.data.Code == 500) {
          alert('系統忙線中，請稍後再試')
        }
      })
      .catch((error) => {
        // console.log('error', error)
        alert(`${error}`)
        window.location.reload()
      })
  },
  //獲取聊天對象列表
  getChatMemberList(context, value) {
    axiosAPI.instance
      .get(`/Chat/list?keyword=${value}`)
      .then((res) => {
        if (res.data.Code == 200) {
          context.commit('GETCHATMEMBERLIST', res.data.Data)
          context.commit('GETMEMBERLIST', true)
        } else if (res.data.Code == 404) {
          alert('查無資料，請重新搜尋')
          context.commit('GETCHATMEMBERLIST', 0)
        } else if (res.data.Code == 401) {
          alert('您已超過一小時未執行任何操作，系統將重新載入頁面')
          window.location.reload()
        } else if (res.data.Code == 500) {
          alert('系統忙線中，請稍後再試')
        }
      })
      .catch((error) => {
        // console.log('error', error)
        alert(`${error}`)
        // window.location.reload()
      })
  },
  //獲取特定聊天對象的聊天內容
  getChatMemberRecords(context, value) {
    axiosAPI.instance
      .get(`/Chat/${value.chatRoomId}?type=${value.type}`)
      .then((res) => {
        if (res.data.Code == 200) {
          context.commit('GETCHATMEMBERRECORDS', res.data.Data)
        } else if (res.data.Code == 404) {
          alert('查無資料')
        } else if (res.data.Code == 401) {
          alert('您已超過一小時未執行任何操作，系統將重新載入頁面')
          window.location.reload()
        } else if (res.data.Code == 500) {
          alert('系統忙線中，請稍後再試')
        }
      })
      .catch((error) => {
        // console.log('error', error)
        alert(`${error}`)
        window.location.reload()
      })
  },
  //取得成員聊天未讀訊息數量
  getNotReadChatCount(context, value) {
    axiosAPI.instance
      .get(`/Chat/notRead/${value}`)
      .then((res) => {
        if (res.data.Code == 200) {
          context.commit('GETNOTREADCHATCOUNT', res.data.Data)
        } else if (res.data.Code == 404) {
          context.commit('GETNOTREADCHATCOUNT', 0)
        } else if (res.data.Code == 401) {
          alert('您已超過一小時未執行任何操作，系統將重新載入頁面')
          window.location.reload()
        } else if (res.data.Code == 500) {
          alert('系統忙線中，請稍後再試')
        }
      })
      .catch((error) => {
        // console.log('error', error)
        alert(`${error}`)
        // window.location.reload()
      })
  },
}

const mutations = {
  //獲取聊天對象列表
  GETCHATMEMBERLIST(state, value) {
    if (value != 0) {
      value.forEach((element) => {
        element.time = PG.getTime(element.time)
      })
      state.memberList = value
    } else {
      state.memberList = []
    }
  },
  //獲取聊天紀錄
  GETCHATMEMBERRECORDS(state, value) {
    value.forEach((element) => {
      element.time = PG.getTime(element.time)
    })
    state.messages = value
    // alert(0)
  },
  //獲取未讀取訊息數量
  GETNOTREADCHATCOUNT(state, value) {
    state.notReadCount = value
  },
  //修改未讀取訊息數量
  CHANGENOTREADCOUNT(state, value) {
    if (value != 0) {
      state.notReadCount++
    } else {
      state.notReadCount = value
    }
  },
  //獲取圖片url
  ADDCHATIMAGE(state, value) {
    state.imageUrl = value[0].imageUrl
  },

  SENDIMAGE(state, value) {
    state.sendImageStatus = value
  },
  SENDMES(state, value) {
    state.sendMesStatus = value
  },

  SENDCENTERIMAGE(state, value) {
    state.sendCenterImageStatus = value
  },

  GETMEMBERLIST(state, value) {
    state.finishGetMemberList = value
  },
}

const state = {
  memberList: [], //聊天對象列表
  messages: [],
  notReadCount: 0,
  imageUrl: '',
  serviceEmail: 'CustomerService@chanchao.com.tw', //設定客服信箱
  sendImageStatus: false,
  sendMesStatus: false,
  sendCenterImageStatus: false,
  finishGetMemberList: false,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
